import { z } from 'zod';

import { AdvisorPropertiesZod } from 'types/zod/advisor-properties';

export const AdvisorDataZod = z
    .object({
        imageUrl: z.string().nullable(),
    })
    .and(AdvisorPropertiesZod);
export type AdvisorData = z.infer<typeof AdvisorDataZod>;
